const URL_REGEX = new RegExp(/^(https?:\/\/)?([a-zA-Z0-9_-]+\.)+[a-zA-Z]{2,63}(\/.*)?$/i);

const EMAIL_REGEX_WITH_NULL_ALLOWED = new RegExp(
  /^(?:([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))?@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})?$/i
);

const EMAIL_REGEX = new RegExp(
  /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i
);

const TEMP_EMAIL_REGEX = new RegExp(/\.temp@gmail\.com/);

const DESCRIPTION_EXTRACT_EMAIL_REGEX = new RegExp(/([a-zA-Z0-9+._-]+@[a-zA-Z0-9._-]+\.[a-zA-Z0-9_-]+)/gi);

const ALLOW_ALPHANUMERIC_REGEX = new RegExp(/^[a-zA-Z0-9]+$/);

export {
  URL_REGEX,
  EMAIL_REGEX_WITH_NULL_ALLOWED,
  EMAIL_REGEX,
  TEMP_EMAIL_REGEX,
  DESCRIPTION_EXTRACT_EMAIL_REGEX,
  ALLOW_ALPHANUMERIC_REGEX,
};
